import { Flex } from '@chakra-ui/react';
import { Button } from 'ui-components';
import {
  CONTENT_DETAIL_MODAL_TRACK_ID,
  ContentDetailModalTrackIdType,
  getContentExternalUrl,
} from '~/components/ContentDetailModal';
import { PlatformLogo } from '~/components/PlatformLogo';
import { SOCIAL_PLATFORMS_NAMES } from '~/constants';
import type { ISearchContentResult } from '~/searchApi';

export interface Props {
  content: ISearchContentResult;
  trackIds: ContentDetailModalTrackIdType;
}

export const AssetDescription = ({ content, trackIds }: Props) => {
  const externalUrl = getContentExternalUrl(content);

  return (
    <Flex
      marginTop={4}
      flexWrap="wrap"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
    >
      <PlatformLogo platform={content.platform} />
      {externalUrl && (
        <Button
          as="a"
          variant="tertiary"
          href={externalUrl}
          rel="noopener noreferrer"
          size="sm"
          target="_blank"
          trackId={trackIds[CONTENT_DETAIL_MODAL_TRACK_ID.viewButton]}
        >
          View in {SOCIAL_PLATFORMS_NAMES[content.platform]}
        </Button>
      )}
    </Flex>
  );
};
